import { ApproverMessage } from '../../../../../types/ApproverMessage';
import { OfferApprovalSettingsMessage } from '../../../../../types/OfferApprovalSettingsMessage';
import { RadioGroup } from '../../../../cdl/RadioGroup/RadioGroup';
import { Text } from '../../../../cdl/Text/Text';
import { translate } from '../../../../common/helpers/translate.helper';
import { Box } from '../../../../common/ui/Box';
import { AdditionalApprovers } from '../../../../offer/MultipleApprovers/components/AdditionalApprovers';
import { TopLevelApprover } from '../../../../offer/MultipleApprovers/components/TopLevelApprover';
import { ApproverList } from '../../components/intelligence/ApproverList';

interface ApproverCheckboxGroupProps {
    offerApprovalSettings: OfferApprovalSettingsMessage;
    selectedApproverEmails: string[];
    onApproverChange: (approver: ApproverMessage) => void;
}

export const ApproverCheckboxGroup = ({
    offerApprovalSettings,
    selectedApproverEmails,
    onApproverChange,
}: ApproverCheckboxGroupProps) => {
    const { suggestedApprovers, additionalApprovers, preventMultipleApprovers } = offerApprovalSettings;
    const hasOnlyOneApprover = suggestedApprovers.length === 1;

    const handleRadioChange = (emailAddress: string) => {
        const approver = [...suggestedApprovers, ...additionalApprovers].find((a) => a.emailAddress === emailAddress);
        if (approver) {
            onApproverChange(approver);
        }
    };

    const content = (
        <>
            {hasOnlyOneApprover ? (
                <Box marginTop={16}>
                    <TopLevelApprover approver={suggestedApprovers[0]} />
                </Box>
            ) : (
                <ApproverList
                    approvers={suggestedApprovers}
                    preventMultipleApprovers={preventMultipleApprovers}
                    selectedApproverEmails={selectedApproverEmails}
                    onApproverChange={onApproverChange}
                />
            )}

            {additionalApprovers.length > 0 ? (
                <Box marginTop={16}>
                    <AdditionalApprovers>
                        <ApproverList
                            approvers={additionalApprovers}
                            preventMultipleApprovers={preventMultipleApprovers}
                            selectedApproverEmails={selectedApproverEmails}
                            onApproverChange={onApproverChange}
                        />
                    </AdditionalApprovers>
                </Box>
            ) : null}
        </>
    );

    return (
        <Box>
            <Text variant="fieldLabel" color="foreground.muted" marginBottom={8} as="h4">
                {translate('closelinkInsights.offerReview.qualifiedApprovers')}
            </Text>

            {preventMultipleApprovers ? (
                <RadioGroup value={selectedApproverEmails[0] || ''} onValueChange={handleRadioChange}>
                    {content}
                </RadioGroup>
            ) : (
                content
            )}
        </Box>
    );
};
